(ns ui.fx.timeout
  (:require
   [re-frame.core :as rf]
   [reagent.core :as r]))

(def timeouts (r/atom {}))

(rf/reg-fx
 ::timeout
 (fn [{:keys [id event wait-ms]}]
   (when-some [existing (get @timeouts id)]
     (js/clearTimeout existing)
     (swap! timeouts dissoc id))
   (when (some? event)
     (swap! timeouts assoc
       id
       (js/setTimeout (fn [_]
                        (rf/dispatch event))
                      wait-ms)))))
